import {
    NinchatActionType,
    NinchatDescribeQueueAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const describeQueue = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeQueueAction}`,
    async (arg: NinchatActionParams<NinchatDescribeQueueAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeQueueAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
